import React, { ReactElement } from "react";
import { Box, Button } from "@mui/material";

interface Props {
  onClick: any;
  children: any;
  isGreen?: any;
  disable?: boolean;
  primary?: boolean;
}

export default function CommonButtonWithOutBor({
  onClick,
  children,
  isGreen = false,
  disable = false,
  primary,
}: Props): ReactElement {
  return (
    <Box component="span" mr={1}>
      <Button
        variant="outlined"
        color={primary ? "primary" : isGreen ? "secondary" : "inherit"}
        size="small"
        component="label"
        onClick={onClick}
        disabled={disable}
        style={{ height: 22 }}
        disableElevation
      >
        {children}
      </Button>
    </Box>
  );
}
